import { RootState } from "redux/rootReducer";

export const selectIsDownloadingCSV = (state: RootState) =>
  state.csvDownloadTypeInfo.loading;
export const csvDownloadErrorMessage = (state: RootState) =>
  state.csvDownloadTypeInfo.error;
export const csvDownloadSuccessResponse = (state: RootState) =>
  state.csvDownloadTypeInfo.csvDownloadTypeInfoResponse;
